// Scene ids the room JSON may reference. One entry per vendored scene file
// (src/deal-room/scenes/vendor/<Id>.tsx). Generated by scripts/sync-scenes.mjs;
// do not edit. Kept React-free so the zod schema can import it.
export const SCENE_IDS = [
    "AccountConsolidation",
    "AccountOwnerStage",
    "AccountProfitCompare",
    "AiAutomation",
    "AiCatalogStage",
    "AplusCreation",
    "BidBudgetOptimization",
    "BrandBuildStage",
    "BrandCarousel",
    "BrandElevation",
    "BrandPlaybook",
    "BuyBoxRace",
    "BuyBoxStage",
    "BuyBoxWin",
    "CampaignPortfolio",
    "CarrierBookingStage",
    "CarrierIntegration",
    "CarrierRateCompare",
    "ChannelAccessStage",
    "ChannelAdsStage",
    "ChannelPricingStage",
    "CompetitorPricing",
    "CompetitorPricingClassic",
    "ConnectionStage",
    "CustomIntegrations",
    "Dayparting",
    "DeliveryTrackStage",
    "DemandChart",
    "EnforcementWorkflow",
    "ExperimentImpact",
    "FastOnboarding",
    "FastReplacement",
    "ImageEnrichment",
    "InfographicCreation",
    "InventoryFlow",
    "IssueResolution",
    "KeywordEditor",
    "LaunchRamp",
    "LaunchRampClassic",
    "ListingCreation",
    "ListingHealthscore",
    "ListingHealthscoreClassic",
    "ListingManagement",
    "ListingManagementClassic",
    "MapGuard",
    "MapWatch",
    "MapWatchStage",
    "MarketplaceExpansion",
    "MoneyWaterfall",
    "MultiMarketplaceAds",
    "NationwideFulfillment",
    "NationwideStage",
    "NewDemandMonthly",
    "NewDemandStage",
    "OnTimeDelivery",
    "OneConnection",
    "PlaybookRewrite",
    "PortalStage",
    "PricingAutomation",
    "PricingEngineGrid",
    "PricingTicker",
    "PricingUniverse",
    "PricingUniverseClassic",
    "ProfitOptimization",
    "ProfitOptimizationClassic",
    "ProfitStackStage",
    "PromoSync",
    "PromoSyncClassic",
    "RegionalPriceStage",
    "RegionalPricing",
    "RegionalShipSpeeds",
    "ReplacementStage",
    "ReturningCustomersStage",
    "ReturnsNetwork",
    "ReturnsQueueStage",
    "ReviewAnalysis",
    "ReviewMonitoring",
    "SearchRanking",
    "SecondLifeStage",
    "SetYourPrice",
    "SetYourPriceStage",
    "ShipSpeedStage",
    "StorefrontStage",
    "SupplierPortal",
    "SupportLoopStage",
    "TailoredStorefront",
    "TechPlatformStage",
    "UnauthorizedSellers",
    "UseOurTechnology",
] as const;

export type SceneId = (typeof SCENE_IDS)[number];
